import getOrganization from '../../data_management/getOrganization'
import getPeople from '../../data_management/getPeople'

const OrganizationController = function ($routeParams, $scope, $location, initialDataInteractor, workspaceInteractor, organizationInteractor) {
  const $ctrl = this;

  initialDataInteractor.ensureInitializedSession()
    .then(() => $scope.$evalAsync(() => {
      $ctrl.people = getPeople(initialDataInteractor);
      $ctrl.organization = getOrganization(initialDataInteractor, $routeParams[ 'id' ]);
      $ctrl.members = filterPeopleListByOrganization($ctrl.people);
      peopleManagerDataInit();
      initSideBar();

      $ctrl.loaded = true;
    }));

  $ctrl.onTabSelected = function (tabId) {
    $ctrl.display = tabId
  };

  $ctrl.createNewWorkspace = function (name) {
    workspaceInteractor.createWorkspaceWithOrganization(name, $ctrl.organization)
      .then(data => $scope.$evalAsync(() => {
        $location.path('/workspace/' + data.id)
      }));
  };

  $ctrl.onPersonCreation = function (newPerson) {
    $ctrl.members.push(newPerson);
    $scope.$digest();
  };

  $ctrl.deleteThisOrganization = function () {
    let confirmed = window.confirm("Are you sure that you want to delete this organization? You won't be able to recover it.");
    if (confirmed) organizationInteractor.deleteOrganization($ctrl.organization.id, () => $scope.$apply(
        () => $location.path('/organizations')
      ));
  };
  $ctrl.memberManagerUpdate = function (newMemberList) {
    let updatedMemberIdList = newMemberList.map(person => person.id);

    organizationInteractor.updateOrganization(updatedMemberIdList, $ctrl.organization.id, $ctrl.organization.name)
      .then(() => $ctrl.onOrganizationUpdate(updatedMemberIdList))
  };

  $ctrl.onOrganizationUpdate = function (updatedMemberIdArray) {
    $ctrl.organization.members = angular.copy(updatedMemberIdArray);
    $ctrl.members = filterPeopleListByOrganization($ctrl.people);
    peopleManagerDataInit();
    $scope.$digest();
  };


  function peopleManagerDataInit() {
    $ctrl.nonMembers = [];

    $ctrl.people.forEach((person) => {
      if (!$ctrl.members.includes(person)) {
        $ctrl.nonMembers.push(person);
      }
    });
  }

  function initSideBar() {
    $ctrl.display = 'members';

    $ctrl.tabs = [ {
      label: 'Members',
      id: 'members'
    }, {
      label: 'Manage Members',
      id: 'manage_members'
    }, {
      label: 'Workspaces',
      id: 'workspaces'
    }, ];
    $ctrl.actions = [ {
      id: 'delete_organization',
      label: 'Delete This Organization',
      callback: $ctrl.deleteThisOrganization,
      class: 'dangerous'
    } ];

    $ctrl.initialSelection = $ctrl.display;
  }

  function filterPeopleListByOrganization(originalPeopleList) {
    let newPeopleList = [];
    originalPeopleList.forEach(function (person) {
      if ($ctrl.organization.members.includes(person.id)) {
        newPeopleList.push(person);
      }
    });
    return newPeopleList;
  }
};

export default {
  name: 'OrganizationController',
  fn: OrganizationController
};
